export default function CustomFilterButton({
  children,
  setActiveCategory,
  activeCategory,
  cat,
}) {
  return (
    <button
      key={cat}
      onClick={() => setActiveCategory(cat)}
      className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
        activeCategory === cat
          ? "bg-primary text-white"
          : "bg-white text-black border-black hover:bg-primary hover:text-white"
      }`}
    >
      {children}
    </button>
  );
}
